<template>
    <div class="content_module" style="background-color:#f9fafc;">
         <div class="back">WEINVENT</div>
         <div class="content">
            <p class="title1">{{service_scope.name}}</p>
            <p class="title2">{{service_scope.value}}</p>
            <p class="title3"><span></span></p>
            <p ref="contentText" style="padding:30px 20px;;font-size:16px;color:#535353;line-height:36px;text-align:left;">{{service_scope.mes}}</p>
            <ul class='model'>
                <li v-for="item in service_scope.items" :ref="'contentImg'+item.ref">
                    <img :src="item.img_src" />
                    <p class='cont'>{{item.mes}}</p>
                </li>
            </ul>
         </div>
    </div>
</template>

<script>
export default {
  name: 'service-scope',
  props:["service_scope"],
  data () {
    return {
    }
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.contentImg1,leftReveal)
    self.$scroll().reveal(self.$refs.contentImg2,fooReveal)
    self.$scroll().reveal(self.$refs.contentImg3,rightReveal)
    self.$scroll().reveal(self.$refs.contentText,topReveal)

  },
}
</script>

<style scoped>
@import '../../../static/css/common.css';

.content{
    position:relative;
}

.model{
    margin: 0 auto 54px auto;
    display:flex;
    justify-content: space-between;
}

.model li{
    display: inline-block;
    width: 30%;
    list-style: none;
    position: relative;
}
.model li img{
    width:100%;
}
.content>.model>li>.cont{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index:1;
    font-size:36px;
    color:#ffffff;
    width:100%;
    padding:0 15px;
    text-align:center;
}
</style>
<style scoped>
    @media screen and (max-width: 570px){
        .model{
            display:flex;
            flex-flow: wrap;
        }
        .model li{
            display: block;
            width: 100%;
            margin-bottom: 20px;
        }
        .model li img{
            width:80%;
        }
        .content>.model>li>.cont{
            position: absolute;
            font-size:28px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/service_scope.vue